<div class="add-stripe-acc-container" *ngIf="accountDetails">
  <form [formGroup]="accountDetails" (ngSubmit)="addExternalBankAccount(accountDetails)">
    <input style="display: none;">
    <h4>Bank Details</h4>
    <div class="form-group">
      <mat-form-field appearance="fill">
        <mat-label>Account Holder Name</mat-label>
        <input matInput placeholder="e.g John" formControlName="name">
      </mat-form-field>

      <div *ngIf="accountDetails.controls.name.touched">
        <small *ngIf="accountDetails.controls.name.hasError('required')" class="text-danger">Account Holder Name is
          Required</small>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-12">
        <mat-form-field appearance="fill">
          <mat-label>Account Number</mat-label>
          <input matInput placeholder="e.g John" formControlName="accountNo">
        </mat-form-field>

        <div *ngIf="accountDetails.controls.accountNo.touched">
          <small *ngIf="accountDetails.controls.accountNo.hasError('required')" class="text-danger">Account number is
            required</small>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-6">
        <mat-form-field appearance="fill">
          <mat-label>Bank Code</mat-label>
          <input matInput placeholder="e.g John" formControlName="bankcode">
        </mat-form-field>
        <div *ngIf="accountDetails.controls.bankcode.touched">
          <small *ngIf="accountDetails.controls.bankcode.hasError('required')" class="text-danger">Bank Code Required
            (e.g 1234)</small>
          <small
            *ngIf="accountDetails.controls.bankcode.hasError('minLength') || accountDetails.controls.bankcode.hasError('maxLength')"
            class="text-danger">Invalid Bank Code: Format = XXXX</small>
          <!-- <small *ngIf="accountDetails.controls.bankcode.hasError('pattern')" class="text-danger">Invalid Bank
            Code</small> -->
        </div>
      </div>
      <div class="col-6">
        <mat-form-field appearance="fill">
          <mat-label>Branch Code</mat-label>
          <input matInput placeholder="e.g John" formControlName="branchcode">
        </mat-form-field>
        <div *ngIf="accountDetails.controls.branchcode.touched">
          <small *ngIf="accountDetails.controls.branchcode.hasError('required')" class="text-danger">Branch Code
            Required</small>
          <small
            *ngIf="accountDetails.controls.branchcode.hasError('minLength') || accountDetails.controls.branchcode.hasError('maxLength')"
            class="text-danger">Invalid Branch Code: Format = XXX</small>
          <!-- <small *ngIf="accountDetails.controls.branchcode.hasError('pattern')" class="text-danger">Invalid Branch
            Code</small> -->
        </div>
      </div>
    </div>

    <button type="submit" class="Gydhwj" [disabled]="!accountDetails.valid">
      Add Bank Account
    </button>
    <p>By registering your account, you agree to our <a href="#tos-acceptance">Services Agreement</a> and the <a
        target="_blank" href="https://stripe.com/connect-account/legal">Stripe Connected Account Agreement</a>.</p>
  </form>
</div>

<ngx-loading [show]="processLoading" [config]="{ backdropBorderRadius: '14px', fullScreenBackdrop: true }">
</ngx-loading>